import { getAgreedDocsDeclaration } from '@porterin/booking-flow/src/auth/domain/helpers/authHelpers';
import { GaEvents } from '@porterin/booking-flow/src/auth/view/stores/AuthAnalyticsStore';
import { useAuthContext } from '@porterin/booking-flow/src/order-review/view/contexts/auth/AuthContext';
import { mapPageToCategory } from '@porterin/booking-flow/src/utils/BookingFlowAnalyticsHelper';
import { publishEvent } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import ReactMarkdown from 'react-markdown';

import { AuthTexts } from '../../stores/AuthStore';
import { getLocaleCookie } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';

const Declaration = () => {
  const { agreedDocs } = useAuthContext();

  const text =
    agreedDocs && getLocaleCookie() === 'en-IN'
      ? getAgreedDocsDeclaration(agreedDocs)
      : AuthTexts.agreementPolicy;

  return (
    <div
      data-testid="declaration-container"
      className="w-full text-lg text-[#62728D] font-normal text-center [&_a]:text-[#0a57ff] [&_a]:font-semibold [&_a]:no-underline mt-[0.8rem]"
      onClick={() => {
        publishEvent({
          category: mapPageToCategory(window.location.pathname),
          action: GaEvents.tncTap,
        });
      }}
    >
      <ReactMarkdown data-testid="declaration-markdown">{text}</ReactMarkdown>
    </div>
  );
};
export default Declaration;
